import { 
    VBtn, VTextarea, VIcon
} from 'vuetify/lib'
import VTable from '@/vuetify_custom/v-table/v3'
import FlowManageTableModal from '@/views/fin/salaryadministration/components/FlowManageTableModal.jsx'
import VPage from '@/vuetify_custom/v-pagination'
import InputModal from '@/views/fin/salaryadministration/components/FlowManagePLTXModal.jsx'
import { getsafe } from '@/libs/util.js'
import flow_mixins from '@/views/hr/PaymentManage/flow_mixins.js'
import { getCustomerSalaryAdjustApplySearchApi } from '@/views/hr/PaymentManage/salaryFlow/service.js'
import { getDownloadTemplate, postCustomerSalaryAdjustApplyDeleteApi, CustomerSalaryAdjustApplyDownBatchAdjustApi } from '@/views/fin/salaryadministration/service.js'
import UserFlowBase from '@/views/components/flow/user_flow_base_jsx_v1'
import {search_type_list} from '@/views/hr/PaymentManage/fields.js'
import SearchHeader from '@/views/hr/PaymentManage/SearchHeader.jsx'
export default {
    mixins: [flow_mixins],
    props: {
  
    },
    data() {
        return {
         
            loading:false,
            params: {
                total_count:0,
                cur_page: 1,
                per_page: 10,
                apply_type: 'batch',
                status: 'normal',
                search_type: 'pending'
            },
            records: [],
            reason: ''
        }
    },
    computed: {
        is_GROUP_PAYMENT_MANAGE() {
            const cur_customer = this.$store.state.cur_customer
            return cur_customer.groups && cur_customer.groups.includes('GROUP_PAYMENT_MANAGE');
        },
        cur_customer() {
            return this.$store.state.cur_customer;
          },
        table_fields() {
            return [
                {
                    text: '序号',
                    align: 'center',
                    value: 'uid',
                    width: 60,
                    render:(v, target, index) => index + 1
                }, 
                {
                    text: '附件名称',
                    align: 'center',
                    value: 'name',
                    render: (v, data) => <div>
                            <span>{v}</span>
                            <VBtn 
                                x-small 
                                text 
                                color="primary" 
                                fab
                                on={{click:() => {
                                    const url = CustomerSalaryAdjustApplyDownBatchAdjustApi(data.id)
                                    window.open(url, '__blank') 
                                }}}
                            ><VIcon >mdi-download</VIcon></VBtn>
                    </div>
                },
                {
                    text: '状态',
                    align: 'left',
                    value: 'index',
                    width: 160,
                    render:(_, item) => {
                        return item.user_flow && <UserFlowBase
                            modelC={item}
                            user_flow={item.user_flow || {}}
                            show_handles={true}
                        /> || '-'
                    }
                },
                {
                    text: '操作',
                    align: 'center',
                    value: 'handle',
                    type: 'button_g_field',
                    width: 200,
                    show: this.is_GROUP_PAYMENT_MANAGE,
                    buttons:({target}) => {
                        const arr = [
                            {
                                text: '查看附件',
                                key: 'edit',
                                color: 'primary',
                                _text: true,
                                small: true,
                               
                               // _text: true,
                                callback: (data) => {
                                    this.$refs.flow_table.edit(data)
                                }
                              }
                        ]
                        const is_action_type = getsafe(target, 'user_flow.current_user_flow_node.user_flow_node_users.0.action_type') === 'submit'
                        const is_my_self = getsafe(target, 'user_flow.current_user_flow_node.user_flow_node_users.0.customer_id') === this.cur_customer.id
                        const is_not_del = !getsafe(target, 'user_flow.del')
                        if (is_action_type &&
                            is_my_self &&
                             is_not_del) {
                                arr.push({
                                    text: '删除',
                                    key: 'edit',
                                    color: 'error',
                                    _text: true,
                                    small: true,
                                   // _text: true,
                                    callback: (data) => {
                                        this.reason = null
                                        this.$vModal.confirm({
                                            title: '提示',
                                            // content: `确定删除${data.file_name}?`,
                                            render:() => <div>
                                                <p>确定删除{data.file_name}?</p>
                                                <div>
                                                    <VTextarea label="原因" v-model={this.reason}/>
                                                </div>
                                            </div>,
                                            loading: true,
                                            // closeContractApi
                                            onOk:({
                                              destroy,
                                              stopLoading
                                            }) => {
                                             postCustomerSalaryAdjustApplyDeleteApi({id:data.id, reason:this.reason}).then(() => {
                                                this.$Message.success('删除成功！')
                                                this.getTableProxy({page: 1})
                                             }).finally(() => {
                                                stopLoading()
                                                destroy()
                                             })
                                             
                                            }   
                                        })
                                    }
                                })
                             }
                             return arr
                    } 
                },
           
            ].filter(i => {
                if (i.show === undefined || i.show) {
                    return true
                }
                return false
            })
        },
    },
    created() {
        const params = this.getParams() || {}
        this.params.status = params.status || 'normal'
        this.params.search_type = params.search_type || 'pending'
        this.$nextTick(this.getTableProxy)
    },
    methods: {
        getTableProxy(params) {
          this.$nextTick(() => this.getTableListtx(params))
        },
        getTableListtx(params) {
            params = params || {}
            // eslint-disable-next-line
            const { total_count,status,search_type, ...other_params } = this.params
            
            this.loading = true
            getCustomerSalaryAdjustApplySearchApi({
                ...other_params,
                ...params,
                status: status || undefined,
                search_type: search_type || undefined,
                }).then(({list, ...other}) => {
                this.records = list
                this.params.total_count = other.total_count
                this.params.per_page = other.per_page
                this.params.page = other.page
            }).finally(() => {
                this.loading = false
            })
        },
    },
    render() {
        console.log('is_GROUP_PAYMENT_MANAGE', this.is_GROUP_PAYMENT_MANAGE)
        return <div >
                    {!!this.is_GROUP_PAYMENT_MANAGE && <div >
                        <div>
                            <span>请下载数据模版并更新数据后上传</span>
                            <span>
                                <VBtn text small color="primary" on={{
                                    click: getDownloadTemplate
                                }}>下载模版</VBtn>
                                <VBtn text small color="primary" 
                                    on={{
                                        click: () => {
                                            this.$refs.modal.edit()
                                        }
                                    }}
                                >导入</VBtn>
                            </span>
                        </div>
                
                    </div>}
       
                <SearchHeader
                     v-model={this.params}
                     searchTypeList={search_type_list.filter(i => i.value !== 0)}
                     on={{
                        change: this.getTableProxy
                    }}
                />
                <div>
                 <VTable
                        headers={this.table_fields}
                        desserts={this.records}
                        loading={this.loading}
                    />  
                </div>
                {!!this.params.total_count && <div class="paginate-fix-bottom">
                    <VPage
                        current={this.params.cur_page}
                        total={this.params.total_count}
                        page-size={this.params.per_page}
                        size-arr={[10, 20, 50]}
                        on={{
                            changePageSize:(per_page) => {
                                this.params.per_page = per_page
                                this.getTableProxy()
                              },
                            pageChange:(new_page) => {
                                this.params.cur_page = new_page
                                this.getTableProxy()
                            }
                        }}
                    />
                </div>}
                <InputModal 
                    ref="modal" 
                    on={{
                        success:() => {
                            this.getTableProxy()
                        }
                    }}/>
                <FlowManageTableModal
                    ref="flow_table"
                />
        </div>
    }
}